import React, { Component } from "react";
import { Dropdown } from "primereact/dropdown";
import { strings } from "../../logik/tuning/frequencies";
import ProductCarousel from "../marketing/ProductCarouselContainer";
import { validatePurchaseOnBackend } from "../../logik/googlepay";

type Props = {
    cookies: boolean;
    onSelect: (e: any, label: string, code: string) => void;
    instrument: null | {
        label: string;
        reverse: boolean;
        key: string;
        strings: {
            note: string;
            freq: number;
        }[];
    };
};

type State = {};

export default class ModellSelection extends Component<Props, State> {
    state = {};

    render() {
        return (
            <>
                <div className="model-select">
                    <div className="p-field">
                        <label htmlFor="fieldId">
                            <b>Tischharfe oder Akkordzither stimmen:</b>
                        </label>
                        <Dropdown
                            value={this.props.instrument}
                            scrollHeight="500px"
                            options={strings}
                            placeholder="Modell wählen"
                            onChange={(e: any) =>
                                this.props.onSelect(
                                    e.value,
                                    e.value.label,
                                    e.value.key
                                )
                            }
                            optionLabel="label"
                            className="w-100"
                        />
                    </div>
                </div>
                <br />
                {this.props.cookies && <ProductCarousel />}
            </>
        );
    }
}
